<template>
  <!-- Dropdown para Selecionar Municípios -->
  <div style="display: flex; flex-direction: column; gap: 16px;">
    <!-- Contêiner das Tags com Scroll -->
    <div class="tags-wrapper">
      <div class="tags-container">
        <b-badge
          v-for="city in selectedCities"
          :key="city"
          variant="info"
          class="tag-item"
          @click="removeTag(city)"
        >
          <span>{{ getCityText(city) }}</span>
          <b-icon-x-circle class="ml-1"></b-icon-x-circle>
        </b-badge>
      </div>
    </div>

    <b-dropdown text="Selecione Municípios" variant="primary" class="mb-3">
      <b-dropdown-form>
        <!-- Campo de Busca -->
        <b-form-group label="Buscar Município:">
          <b-form-input
            v-model="search"
            placeholder="Digite para filtrar..."
            class="mb-2"
          ></b-form-input>
        </b-form-group>

        <!-- Lista com Scroll -->
        <div class="dropdown-scroll">
          <div v-if="isLoading" class="d-flex align-items-center mb-2">
            <b-spinner small type="grow" label="Carregando..." />
            <span class="ml-2">Carregando cidades...</span>
          </div>
          <b-form-checkbox
            v-for="city in filteredCities"
            :key="city.value"
            @change="handleChange"
            v-model="selectedCities"
            :value="city.value"
          >
            {{ city.text }}
          </b-form-checkbox>
        </div>
      </b-dropdown-form>
    </b-dropdown>
  </div>
</template>

<script>
import { Api } from '../../../../vue/api';
const API = new Api();

export default {
  name: 'CitySelect',
  props: {
    value: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      citiesOptions: [], // Opções carregadas do backend
      selectedCities: this.value, // Municípios selecionados
      search: '', // Texto de pesquisa
      isLoading: false,
    };
  },
  computed: {
    filteredCities() {
      // Filtra municípios com base na pesquisa
      if (!this.search) return this.citiesOptions;
      return this.citiesOptions.filter(city =>
        city.text.toLowerCase().includes(this.search.toLowerCase()),
      );
    },
  },
  async created() {
    await this.fetchCities();
  },
  methods: {
    async fetchCities() {
      this.isLoading = true;
      try {
        const { ok, model, errors } = await API.post('/execute', {
          path: `/lead-management/qualified-leads/cities`,
          method: 'get',
        });
        if (!ok) {
          this.$bvToast.toast(errors.message, {
            title: `Erro`,
            variant: 'error',
            solid: true,
          });
          return;
        }
        const options = model.map(city => ({
          value: city.code,
          text: `${city.code} - ${city.description}`,
        }));
        this.citiesOptions = options;
      } catch (error) {
        this.$bvToast.toast(error.message, {
          title: 'Erro',
          variant: 'error',
          solid: true,
        });
      } finally {
        this.isLoading = false;
      }
    },

    removeTag(value) {
      this.selectedCities = this.selectedCities.filter(city => city !== value);
      this.handleChange();
    },

    getCityText(value) {
      const city = this.citiesOptions.find(m => m.value === value);
      return city ? city.text : value;
    },
    handleChange() {
      this.$emit('input', this.selectedCities);
    },
  },
};
</script>

<style scoped>
/* Dropdown Scroll */
.dropdown-scroll {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 8px;
}

/* Wrapper para as tags */
.tags-wrapper {
  width: 400px; /* Largura Máxima */
  max-width: 400px;
  min-height: 40px;
  max-height: 80px; /* Altura Máxima */
  overflow-y: auto; /* Ativa scroll após atingir altura máxima */
  border: 1px solid #ddd;
  padding: 8px;
  border-radius: 4px;
  background-color: #f8f9fa;
}

/* Container das Tags */
.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* Estilo individual das tags */
.tag-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 4px 8px;
  font-size: 14px;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  max-width: 100%;
  word-break: break-word;
}

.tag-item:hover {
  background-color: #0056b3;
}

.tag-item .b-icon-x-circle {
  margin-left: 5px;
}

/* Estilização para o campo de busca */
.b-form-input {
  margin-bottom: 8px;
}
</style>
